import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { TICKER_REGEX_PATTERN } from "../shared/crud/form-validation";

export const messages = defineMessages({
  tickerValdiation: {
    id: "app.ticker.validation",
    description: "ticker valdiation text",
    defaultMessage: " doesn't allow blank spaces and special characters except underscore ( _ )",
  },
  ibanValidator: {
    id: "app.iban.validation",
    description: "iban valdiation text",
    defaultMessage: "Invalid IBAN",
  },
  presenceValidator: {
    id: "app.input.pressence",
    description: "ticker valdiation text",
    defaultMessage: " doesn't allow blank spaces and special characters except underscore ( _ )",
  },
  tickerLengthValidation: {
    id: "app.ticker.lengthValidation",
    description: "lengthValidation Text",
    defaultMessage: "Ticker is too long",
  },
  installmentsValuesValidation: {
    id: "app.paymentTypes.installmentValuesValidation",
    description: "Adyen installmentValues Validation",
    defaultMessage: "Installments values only must be comma separated numbers",
  },
});

export const tickerValidator = {
  type: "String",
  constraints: {
    presence: {
      allowEmpty: false,
    },
    format: {
      pattern: TICKER_REGEX_PATTERN,
      message: <FormattedMessage {...messages.tickerValdiation} />,
    },
  },
};

export const autocompleteValidator = {
  type: "String",
  constraints: {
    autocompleteOption: {},
  },
};
